<template>
  <div class="d-flex align-center">
    <profile-membership class="hide--in-mobile" style="margin-right: 16px"></profile-membership>
    <v-menu
      left
      offset-y
      nudge-bottom="10"
      nudge-left="8"
      content-class="header--popup-container header-user--menu hide--in-mobile"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <div class="user--dropdown-button" v-if="user">
            <div class="profile--picture-wrapper">
              <img class="profile--picture" :src="user.photo_profile_user" />
            </div>
            <div class="profile--name-row">
              <div class="profile--name">{{ user.name }}</div>
              <img
                v-if="isAgenNaikKelas"
                src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/agen-naik-kelas/agen-naik-kelas-badge.svg"
                alt="Agen Naik Kelas"
                class="agen-naik-kelas-badge"
                title="Anda adalah Agen Naik Kelas"
              />
            </div>
            <i class="ion-ios-arrow-down ml-2"></i>
          </div>
          <div v-else>
            <img src="@/assets/img/icons/user.svg" class="single--button" />
            <i class="ion-ios-arrow-down ml-2"></i>
          </div>
        </div>
      </template>
      <router-link to="/profile" class="popup--item">
        <span class="popup--item-icon"><v-icon>mdi-account-outline</v-icon></span>
        <span>{{ $t('home.sidebarMenu.profile') }}</span>
      </router-link>
      <router-link to="/product" class="popup--item">
        <span class="popup--item-icon">
          <img src="@/assets/icons/menus/beli-paket.svg" alt="Beli Paket" />
        </span>
        <span>{{ $t('home.sidebarMenu.product') }}</span>
      </router-link>
      <router-link to="/" class="popup--item">
        <span class="popup--item-icon">
          <img src="@/assets/icons/menus/listing-saya.svg" alt="Listing Saya" />
        </span>
        <span>{{ $t('home.sidebarMenu.myListing') }}</span>
      </router-link>
      <router-link to="/layanan-agen/agen-properti-pilihan" class="popup--item">
        <span class="popup--item-icon">
          <img src="@/assets/icons/featured-features/agen-pilihan.svg" alt="Agen Pilihan" />
        </span>
        <span>{{ $t('home.sidebarMenu.featuredAgent') }}</span>
      </router-link>
      <router-link v-if="enableRecommendedListing" to="/recommended-listing" class="popup--item">
        <span class="popup--item-icon"><v-icon>mdi-star-circle-outline</v-icon></span>
        <div class="popup--item-label">
          <span>{{ $t('home.sidebarMenu.recommendedListing') }}</span>
          <span class="featured-menu--highlight">{{ $t('general.new') }}</span>
        </div>
      </router-link>
      <router-link to="/order" class="popup--item">
        <span class="popup--item-icon">
          <img src="@/assets/icons/menus/pembelian-saya.svg" alt="Pembelian Saya" />
        </span>
        <span>{{ $t('home.sidebarMenu.myOrder') }}</span>
      </router-link>
      <router-link to="/coin-purchase" class="popup--item">
        <span class="popup--item-icon">
          <img src="@/assets/icons/menus/coin-saya.svg" alt="Koin Saya" />
        </span>
        <span>{{ $t('home.sidebarMenu.myCoin') }}</span>
      </router-link>
      <router-link v-if="isProOrExecutive" to="/layanan-agen/owner-connect" class="popup--item">
        <span class="popup--item-icon">
          <img src="@/assets/icons/featured-features/owner-connect.svg" alt="Owner Connect" />
        </span>
        <span>{{ $t('home.sidebarMenu.ownerConnect') }}</span>
      </router-link>
      <router-link v-if="isProOrExecutive" to="/layanan-agen/project-connect" class="popup--item">
        <span class="popup--item-icon">
          <img src="@/assets/icons/featured-features/project-connect.svg" alt="Project Connect" />
        </span>
        <span>{{ $t('home.sidebarMenu.projectConnect') }}</span>
      </router-link>
      <router-link to="/layanan-agen/agen-naik-kelas" class="popup--item">
        <span class="popup--item-icon">
          <img src="@/assets/icons/featured-features/agen-naik-kelas.svg" alt="Agen Naik Kelas" />
        </span>
        <span>{{ $t('home.sidebarMenu.agenNaikKelas') }}</span>
      </router-link>
      <!--      <router-link to="/shortlist" class="popup&#45;&#45;item">-->
      <!--        {{ $t('home.sidebarMenu.shortlist') }}-->
      <!--      </router-link>-->
      <router-link to="/leads" class="popup--item">
        <span class="popup--item-icon"><v-icon>mdi-email-outline</v-icon></span>
        <div class="popup--item-label">
          {{ $t('home.sidebarMenu.myLeads') }}
          <div v-if="enquiriesUnreadCount" class="unread--counter">{{ enquiriesUnreadCount }}</div>
        </div>
      </router-link>
      <!--    <router-link to="/dashboard/myproject" class="popup&#45;&#45;item">-->
      <!--      {{ $t('home.sidebarMenu.myproject') }}-->
      <!--    </router-link>-->
      <!--    <router-link to="/dashboard/mybooking" class="popup&#45;&#45;item">-->
      <!--      {{ $t('home.sidebarMenu.mybooking') }}-->
      <!--    </router-link>-->
      <!--    <router-link to="/favorites" class="popup&#45;&#45;item">-->
      <!--      {{ $t('home.sidebarMenu.fave') }}-->
      <!--    </router-link>-->
      <div class="popup--item" @click="logout">
        <span class="popup--item-icon is-danger"><v-icon>mdi-logout</v-icon></span>
        <span>{{ $t('home.sidebarMenu.logout') }}</span>
      </div>
    </v-menu>
  </div>
</template>

<script>
import auth from '@/mixins/auth.js';
import ProfileMembership from '@/components/utils/profile-membership';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'header-user',
  mixins: [auth],
  components: {
    ProfileMembership,
  },
  computed: {
    ...mapState({
      user: (state) => state.global.user,
      enquiriesUnreadCount: (state) => state.global.enquiriesUnreadCount,
      enableRecommendedListing: (state) => state.global.enableRecommendedListing,
    }),
    ...mapGetters({
      isAgenNaikKelas: 'global/isAgenNaikKelas',
      isProOrExecutive: 'global/isProOrExecutive',
    }),
  },
};
</script>
